import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingService, OnboardingState } from '../../core/service/onboarding.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-onboarding-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.scss']
})
export class OnboardingModalComponent implements OnInit, OnDestroy {
  onboardingState: OnboardingState = {
    isActive: false,
    currentStep: 0,
    totalSteps: 3
  };

  private subscription = new Subscription();

  steps = [
    {
      title: 'Welcome to your free trial of Talonic ⭐',
      content: '',
      buttonText: 'Next'
    },
    {
      title: 'You have 100 credits to explore our AI data structuring.',
      content: 'Credits don\'t expire and 1 credit equals 1 page.',
      buttonText: 'Next'
    },
    {
      title: 'Experience all basic features during your trial 🏆',
      content: 'Including AI structure generation and multi-document structuring.',
      buttonText: 'Start Free Trial'
    }
  ];

  constructor(private onboardingService: OnboardingService) {}

  ngOnInit(): void {
    this.subscription.add(
      this.onboardingService.onboardingState$.subscribe(state => {
        this.onboardingState = state;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleNext(): void {
    this.onboardingService.nextStep();
  }

  getDotClass(index: number): string {
    if (index < this.onboardingState.currentStep) {
      return 'filled';
    } else if (index === this.onboardingState.currentStep) {
      return 'filled';
    }
    return '';
  }
}



